export enum StatsGroupEnum {
  Client = 0,
  Company = 1,
  Region = 2,
  Group = 3,
  Location = 4,
  Device = 5,
  Game = 6,
  DeviceTypeEnum = 7,
  CCY = 8,
  PaymentType = 9,
}
